import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import WizardSignForm from 'Components/WizardSignForm';
import useWootricSurvey from 'Hooks/Common/useWootricSurvey';
import { DocumentTypes } from 'Interfaces/Document';
import { AuthorizedRoutePaths, slugStartRoutesMap } from 'Interfaces/RoutePaths';
import { User } from 'Interfaces/User';
import {
  selectShowPlanUpgradeSuccessPage,
  selectShowTrialSuccessPage,
  selectUser,
} from 'Utils/selectors';

interface DashboardLocationContext {
  showTrialSuccessPage?: boolean;
  showPlanUpgradeSuccessPage?: boolean;
}

const Dashboard = () => {
  const navigate = useNavigate();
  const locationState = useLocation().state as DashboardLocationContext;

  const { email, createdAt, plan }: User = useSelector(selectUser);
  const showTrialSuccessPage =
    useSelector(selectShowTrialSuccessPage) || locationState?.showTrialSuccessPage;
  const showPlanUpgradeSuccessPage =
    useSelector(selectShowPlanUpgradeSuccessPage) ||
    locationState?.showPlanUpgradeSuccessPage;

  useWootricSurvey(email as string, createdAt as Date);

  const initialValues = useMemo(() => {
    return {
      type: DocumentTypes.ME,
      signers: [
        {
          name: 'Me (Now)',
          email: email,
          order: -1,
          isPreparer: true,
        },
      ],
    };
  }, [email]);

  useEffect(() => {
    if (showTrialSuccessPage) {
      navigate(AuthorizedRoutePaths.TRIAL_SUCCESS, { state: { successRequired: true } });
    }

    if (showPlanUpgradeSuccessPage) {
      navigate(slugStartRoutesMap[plan.type], {
        state: { successRequired: true },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="dashboard__wrapper">
      <WizardSignForm initialValues={initialValues} isEditMode={false} />
    </div>
  );
};

export default Dashboard;
